import { createContext, useState } from 'react';
import { useSetGetDelete } from '../../hooks';
import { keys } from '../../models';


const AppContext = createContext();


const AppContextProvider = ({children}) => {

    const [ selectedMenuItem, setSelectedMenuItem ] = useState('dashboard');

    const [ allPublications, setAllPublications ] = useState([]);
    const [ allHilightPublications, setAllHilightPublications ] = useState([]);

    const [ idEditPublication, setIdEditPublication, deleteIdEditPublication ] = useSetGetDelete(null, keys.EDITINGPUBID);
    const [ editPublication, setEditPublication ] = useState({});
    // const [ editPublication, setEditPublication ] = useSetGetDelete({}, keys.EDITINGPUB);

    const [ pubsPerPage, setPubsPerPage ] = useState(10);
    const [ currentPage, setCurrentPage, ] = useState(1);
    const [ totalPublications, setTotalPublications ] = useState(0);
    const [ totalPages, setTotalPages ] = useState(0);

    const [ previewPubId, setPreviewPubId ] = useState();

    const [ arranges, setArranges ] = useState([]);

    const [ yearVisits, setYearVisits ] = useState(0);
    const [ monthVisits, setMonthVisits ] = useState(0);
    const [ weekVisits, setWeekVisits ] = useState(0);
    const [ last7Days, setLast7Days ] = useState(0);
    const [ last30Days, setLast30Days ] = useState(0);
    const [ todayVisits, setTodayVisits ] = useState(0);

    const [ yearLoading, setYearLoading ] = useState(false);
    const [ monthLoading, setMonthLoading ] = useState(false);
    const [ weekLoading, setWeekLoading ] = useState(false);
    const [ last7Loading, setLast7Loading ] = useState(false);
    const [ last30Loading, setLast30Loading ] = useState(false);
    const [ todayLoading, setTodayLoading ] = useState(false);
    
    return (
        <AppContext.Provider
            value={{
                selectedMenuItem, setSelectedMenuItem,

                allPublications, setAllPublications,
                allHilightPublications, setAllHilightPublications,
                
                idEditPublication, setIdEditPublication, deleteIdEditPublication,
                editPublication, setEditPublication,
                
                pubsPerPage, setPubsPerPage,
                currentPage, setCurrentPage,
                totalPublications, setTotalPublications,
                totalPages, setTotalPages,

                previewPubId, setPreviewPubId,

                arranges, setArranges,

                yearVisits, setYearVisits,
                monthVisits, setMonthVisits,
                weekVisits, setWeekVisits,
                last7Days, setLast7Days,
                last30Days, setLast30Days,
                todayVisits, setTodayVisits,

                yearLoading, setYearLoading,
                monthLoading, setMonthLoading,
                weekLoading, setWeekLoading,
                last7Loading, setLast7Loading,
                last30Loading, setLast30Loading,
                todayLoading, setTodayLoading,
            }}
        >
            {children}
        </AppContext.Provider>
    )
};

export default AppContext;
export { AppContextProvider };
